<template>
  <div class="nothing-box" :style="{ visibility: show ? 'visible' : 'hidden' }">
    <div class="imgs">
      <img :width="width" :src="`image/none/${config.type || 'img_no_data'}.png`" alt="" />
    </div>
    <span class="tip">{{ config.tip || "暂无数据" }}</span>
    <wf-button v-permission="config.permission" class="nothing-btn" @click="btnCheck" v-if="config.btnText" :icon="`icon iconfont ${config.icon || 'iconicon_enlarge'}`">{{ config.btnText || "添加" }}</wf-button>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '200px'
    },
    config: {
      type: [Array, Object],
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 300);
  },
  methods: {
    btnCheck() {
      console.log(777)
      this.$emit("button-click");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.nothing-box {
  text-align: center;
  min-width: 220px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .imgs {
    // height: 214px;
    // img {
    //   width: 200px;
    // }
  }
  // img {
  //   width: 100%;
  //   height: 100%;
  // }
  .tip {
    @include fontColorOpacity(.6);
    font-size: 14px;
    margin: 14px 0 40px 0;
    display: block;
  }
  .nothing-btn {
    // min-width: 200px;
    // height: 40px;
    // background: linear-gradient(225deg, #2fa9ff 0%, #0d70e8 100%);
    box-shadow: 0px 12px 41px -7px #2fa9ff;
    // border-radius: 4px;
    // color: #fff;
    // line-height: 40px;
    // font-size: 14px;
    // display: inline-block;
    // &:hover {
    //   cursor: pointer;
    //   opacity: 0.9;
    // }
    // i {
    //   color: #fff;
    // }
  }
}
</style>
